import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeople: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconPeople"><Path d="M12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11C14.4853 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4853 2 12 2Z" fill="currentColor"/><Path d="M12.0014 12.5C8.27968 12.5 5.43692 14.7258 4.28043 17.8527C3.97401 18.6813 4.18231 19.4953 4.67127 20.078C5.14989 20.6484 5.89317 21 6.69823 21H17.3046C18.1096 21 18.8529 20.6484 19.3315 20.078C19.8205 19.4953 20.0288 18.6813 19.7223 17.8527C18.5659 14.7258 15.7231 12.5 12.0014 12.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeople;
